var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isShowBanner ? _c('div', {
    staticClass: "banner-box",
    style: {
      height: _vm.bannerHeight + 'px'
    }
  }, [_c('img', {
    staticClass: "banner-img",
    style: {
      height: _vm.bannerHeight + 'px'
    },
    attrs: {
      "src": _vm.bannerData.pic
    }
  })]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };